/** PendingApproval rows are not field-editable — use `action` for approve/reject. */
const PENDING_APPROVAL_SKIP_EDIT = { PendingApproval: ['edit'] };

const APP_CONST: any = {
    VERSION: 'v1',
    /** Fallback app title when Settings → default → appTitle is empty. */
    TITLE_APP: 'Fuse Automotive',

    KEY_STORE_USER: 'AppSession',
    KEY_STORE_ROLES: 'AppRoles',
    KEY_STORE_ACC: 'AppAccount',
    KEY_STORE_PERMISSION: 'AppPermissions',
    KEY_STORE_PREFERENCE: 'AppPreference',
    KEY_STORE_SETTING: 'AppSetting',

    PATH_APP_SALE: '/app/sale',
    PATH_APP_ADMIN: '/app/admin',

    PATH_API: '/api/v/web/v1',
    PATH_LOGIN: '/app/login',
    PATH_APP: '/app/v1',

    ONLY_FRONTEND: false,
    TIMEOUT_TOKEN: 3600,
    TIMEOUT_DEBOUNCE: 500,
    /** Client axios wait for NS Sync (server calls NetSuite; default axios is 30s). */
    HTTP_TIMEOUT_NETSUITE_MS: 120000,
    /** Dashboard widget run/preview — heavy SQL can exceed default 30s axios timeout. */
    HTTP_TIMEOUT_DASHBOARD_WIDGET_MS: 120000,
    /** Woo push/preview: server may call Woo REST many times (taxonomy + image batches). */
    HTTP_TIMEOUT_WOOCOMMERCE_MS: 300000,
    /** Woo push progress poll — must exceed heavy image resize / sync stretches on the worker. */
    HTTP_TIMEOUT_WOO_PUSH_PROGRESS_MS: 120000,

    /** Fired after customer refund cancel (list) so open QUO/SO/IV screens can reload payments / balances. */
    CUSTOMER_FINANCIAL_REFRESH_EVENT: 'usedcar:customer-financial-refresh',

    LIMIT_PAGE: 10,
    LIMIT_OPTIONS_PAGE: 50,

    // Loan calculation method: 'flat' for Malaysian standard (linear), 'reducing' for compound interest
    LOAN_CALCULATION_METHOD: 'flat',

    CLASS_COLORS: {
        primary: 'bg-blue-100 text-blue-700',
        success: 'bg-green-100 text-green-700',
        error: 'bg-red-100 text-red-700',
        orange: 'bg-orange-100 text-orange-700',
        indigo: 'bg-indigo-100 text-indigo-700',
        gray: 'bg-gray-300 text-gray-700',
    },

    MODULE_STATUS: {
        SUP: { name: 'Vendor', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        PO: {
            name: 'PurchaseOrder',
            statusControl: true,
            skipStatus: [],
            status: [
                'New', 'Rejected', 'PendingApproval',
                'FinanceVerification', 'FinanceVerificationFailed',
                'PendingInventoryReceive', 'InventoryReceived',
                'QCVerification', 
                // 'QCConfirm', 
                // 'QCInProgress', 
                'FinalizeDocument', 'InvalidDocument', 'FinalizePayment', 'Closed', 'Cancelled'
            ],
            skipAccess: [],
            skipStatusAccess: { Closed: ['edit'], Cancelled: ['edit'], ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: ['revise'],
        },
        INS: {
            name: 'Inspection',
            statusControl: true,
            skipStatus: [],
            status: ['Draft', 'Pending', 'Completed', 'PendingApproval', 'Cancelled', 'PendingReview', "Rejected"],
            skipAccess: [],
            skipStatusAccess: { ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: [],
        },
        PRQ: {
            name: 'PaymentRequest',
            statusControl: true,
            skipStatus: [],
            status: ['Draft', 'Request', 'Pending', 'Rejected', 'PendingApproval', 'Completed'],
            skipAccess: [],
            skipStatusAccess: { ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: [],
        },

        CUS: { name: 'Customer', statusControl: false, skipStatus: [], status: ['Lead', 'Customer'], skipAccess: [], extraAccess: [], },
        QUO: {
            name: 'Quotation',
            statusControl: true,
            skipStatus: [],
            status: [
                'Draft', 'Rejected', 'PendingApproval', 
                // 'Approved', 'LoanApplication', 'LoanRejected','LoanApproved', 
                'Processing', 'Completed', 'Cancelled'
            ],
            skipAccess: [],
            skipStatusAccess: { Cancelled: ['edit'], ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: [],
        },
        SO: {
            name: 'SalesOrder',
            statusControl: true,
            skipStatus: [],
            status: ['New', 'Rejected', 'PendingApproval', 'Processing', 'Delivered', 'Completed', 'Cancelled'],
            skipAccess: [],
            skipStatusAccess: { Cancelled: ['edit'], ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: [],
        },
        DO: {
            name: 'DeliveryOrder',
            statusControl: false,
            skipStatus: [],
            status: ['All'],
            skipAccess: [],
            extraAccess: [],
        },
        IV: {
            name: 'Invoice',
            statusControl: true,
            skipStatus: [],
            status: ['New', 'Completed', 'Cancelled'],
            skipAccess: [],
            skipStatusAccess: { Cancelled: ['edit'] },
            extraAccess: [],
        },
        CSN: {
            name: 'ConsignmentNote',
            statusControl: false,
            skipStatus: [],
            status: ['All'],
            skipAccess: [],
            extraAccess: [],
        },

        // EXP: {
        //     name: 'Expense',
        //     statusControl: false,
        //     skipStatus: [],
        //     status: ['New', 'Pending', 'Completed', 'Cancelled'],
        //     skipAccess: [],
        //     extraAccess: [],
        // },

        LNA: {
            name: 'LoanApplication',
            statusControl: false,
            skipStatus: [],
            status: ['New', 'Processing', 'Approved', 'Rejected', 'Cancelled'],
            skipAccess: [],
            extraAccess: [],
        },
        LND: {
            name: 'LoanDisbursement',
            statusControl: false,
            skipStatus: [],
            status: ['All'],
            skipAccess: [],
            extraAccess: [],
        },
        CPY: {
            name: 'CustomerPayment',
            statusControl: true,
            skipStatus: [],
            status: ['New', 'Confirmed', 'PartialRefund', 'Refund', 'Rejected', 'Cancelled'],
            skipAccess: [],
            skipStatusAccess: { Cancelled: ['edit'] },
            extraAccess: [],
        },
        CRF: {
            name: 'CustomerRefund',
            statusControl: true,
            skipStatus: [],
            status: [
                'New',
                'PendingApproval',
                'ApprovalRejected',
                'Rejected',
                'Pending',
                'Completed',
                'Cancelled',
            ],
            skipAccess: [],
            skipStatusAccess: { ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: [],
        },
        
        QCW: {
            name: 'QCWorkOrder',
            statusControl: true,
            skipStatus: [],
            status: ['Draft', 'Confirmed', 'PendingCheckIn', 'Completed'],
            skipAccess: [],
            skipStatusAccess : {},
            extraAccess: [],
        },
        QCWT: {
            name: 'QCWorkOrderTask',
            statusControl: true,
            skipStatus: [],
            status: ['Draft', 'Pending', 'InProgress', 'Paused', 'PendingQC', 'Transition', 'Completed'],
            skipAccess: [],
            skipStatusAccess : {},
            extraAccess: ['revise'],
        },
        STX: { 
            name: "StockTransfer",
            statusControl: false,
            skipStatus: [],
            status: ['All'],
            skipAccess: [],
            extraAccess: [],
        },
        
        

        /// Master
        
        // SEL: { name: 'Seller', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // BRK: { name: 'Broker', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // VND: { name: 'Vendor', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        
        CAR: { name: 'Car', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        CIV: { name: 'CarInventory', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        /** Car inventory cost header + payment lines — field mapping module code CCT */
        CCT: { name: 'CarInventoryCost', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        IPR: { name: 'ItemPrice', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        IPB: {
            name: 'ItemPriceBatch',
            statusControl: true,
            skipStatus: [],
            status: ['Draft', 'PendingApproval', 'Applying', 'Completed', 'ApplyFailed', 'Rejected'],
            skipAccess: [],
            skipStatusAccess: { ...PENDING_APPROVAL_SKIP_EDIT },
            extraAccess: [],
        },
        VCT: { name: 'ViewCost', statusControl: false, skipStatus: [], status: ['All'], skipAccess: ['cancel', 'create', 'edit'], extraAccess: [], },
        SPL: { name: 'SettlementCost', statusControl: false, skipStatus: [], status: ['All'], skipAccess: ['cancel', 'create', 'edit'], extraAccess: [], },
        NSI: { name: 'NetsuiteIntegration', statusControl:false, skipStatus:[], status: ['All'], skipAccess: ['cancel', 'create', 'edit', 'view'], extraAccess: [], },
        PSF: { name: 'PartySensitiveFields', statusControl: false, skipStatus: [], status: ['All'], skipAccess: ['cancel', 'create', 'view'], extraAccess: [], },
        USR: { name: 'User', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        SET: { name: 'Settings', statusControl: false, skipStatus: [], status: ['All'], skipAccess: ['cancel', 'create'], extraAccess: [], },
        PCL: { name: 'PeriodClosing', statusControl: false, skipStatus: [], status: ['All'], skipAccess: ['cancel'], extraAccess: [], },
        ROL: { name: 'Role', statusControl: false, skipStatus: [], status: ['All'], skipAccess: ['cancel'], extraAccess: [], },
        APL: { name: 'Approval', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        APT: { name: 'ApprovalTransaction', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: ['action'], },
        RPT: { name: 'Report', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        LST: { name: 'ListingMaintenance', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },

        ///Records:
        // LOC: { name: 'Location', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [],extraAccess: [], },
        // SHR: { name: 'Showroom', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // BRD: { name: 'Brand', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // BNK: { name: 'Bank', skipControl: true, statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // ACT: { name: 'AdditionalChargeType', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // AST: { name: 'AccessoryType', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // ACC: { name: 'Accessory', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // QWS: { name: 'QC Workstation', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // QCT: { name: 'QC Task', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
        // QCTT: { name: 'QC Task Template', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
       
        TD: { name: 'Todo', statusControl:false, skipStatus:[], status: ['All'], skipAccess: [], extraAccess: [], },
        RCD: { name: 'Record', statusControl: false, skipStatus: [], status: ['All'], skipAccess: [], extraAccess: [], },
    },

    MODULE_DASHBOARD_MAP: {
        PO: {
            name: 'PurchaseOrder',
            icon: 'description',
            color: 'blue',
            url: '/app/v1/pos',
            status: {
                New: { label: 'New', icon: 'label' },
                Rejected: { label: 'Rejected', icon: 'label' },
                PendingApproval: { label: 'Pending Approval', icon: 'label' },
                PendingInventoryReceive: { label: 'Pending Inventory Receive', icon: 'label' },
                FinanceVerification: { label: 'Finance Verification', icon: 'label' },
                FinanceVerificationFailed: { label: 'Finance Verification Failed', icon: 'label' },
                PendingPayment: { label: 'Pending Payment', icon: 'label' },
                PaymentRejected: { label: 'Pending Rejected', icon: 'label' },
                // InventoryReceived: { label: 'Inventory Received', icon: 'label' }, 
                QCVerification: { label: 'QC Verification', icon: 'label' },
                // QCConfirm: { label: 'QC Confirm', icon: 'label' },
                // QCInProgress: { label: 'QC InProgress', icon: 'label' },
                FinalizeDocument: { label: 'Finalize Document', icon: 'label' },
                InvalidDocument: { label: 'Invalid Document', icon: 'label' },
                FinalizePayment: { label: 'Finalize Payment', icon: 'label' },
                Closed: { label: 'Closed', icon: 'label' },
                Cancelled: { label: 'Cancelled', icon: 'label' },
            }
        },
        QUO: {
            name: 'Quotation',
            icon: 'description',
            color: 'red',
            url: '/app/v1/quos',
            status: {
                New: { label: 'New', icon: 'label' },
                Rejected: { label: 'Rejected', icon: 'label' },
                PendingApproval: { label: 'Pending Approval', icon: 'label' },
                Approved: { label: 'Approved', icon: 'label' },
                LoanApplication: { label: 'Loan Application', icon: 'label' },
                LoanRejected: { label: 'Loan Rejected', icon: 'label' },
                LoanApproved: { label: 'Loan Approved', icon: 'label' },
                Processing: { label: 'Processing', icon: 'label' },
                Completed: { label: 'Completed', icon: 'label' },
            }
        },

    },

    MODULE_URL_MAP: {
        PO: 'pos',
        QUO: 'quos',
        PRQ: 'prqs',
        SUP: 'vendors',
        CUS: 'customers',
        QCW: 'qcworkorders',
        INS: 'inspections',
        CIV: 'carinventorys',
        SO: 'salesorders',
        IV: 'invoices',
        LNA: 'loanapplications',
        LND: 'loandisbursements',
        DO: 'deliveryorders',
        CPY: 'customerpayments',
        CRF: 'customerrefunds',
        /** Customer refund / payment tabs use full table name as sourceType */
        CUSTOMERPAYMENT: 'customerpayments',
        CCT: 'carinventorycosts',
        STX: 'stxs',
    },

    PALETTE: {
        '50': '#e2e7eb',
        '100': '#b6c2ce',
        '200': '#869aad',
        '300': '#55728c',
        '400': '#305373',
        '500': '#0c355a',
        '600': '#0a3052',
        '700': '#082848',
        '800': '#06223f',
        '900': '#03162e',
        'A100': '#679dff',
        'A200': '#347cff',
        'A400': '#015bff',
        'A700': '#0052e6',
        'contrastDefaultColor': 'light',
        'contrastDarkColors': [
            '50',
            '100',
            '200',
            'A100'
        ],
        'contrastLightColors': [
            '300',
            '400',
            '500',
            '600',
            '700',
            '800',
            '900',
            'A200',
            'A400',
            'A700'
        ]
    },

    // TAILWIND PALETTE CLASS
    TW_PALLETE: {
        MAIN_THEME_BG_COLOR: 'bg-[rgb(8,40,72)]',

        TEXT_ON_WHITE_BG: 'text-slate-600',
        TEXT_ON_DARK_BG: 'text-slate-100',
        WHITE_BG: 'bg-white',
        GRAY_BG: 'bg-slate-200',
        DARK_BG: 'bg-slate-600',

        SELECT_BG_COLOR: 'bg-white',

        TABLE_HEADER_COLOR: 'bg-[rgb(8,40,72)]',
        TABLE_SELECTED_COLOR: 'bg-sky-200',
        TABLE_HOVER_COLOR: 'bg-slate-600/20',
        TABLE_CHECKED_COLOR: 'bg-sky-300/30',
    },


    // HARDCODED ATTACHMENT TYPES
    CAR_THUMBNAIL: 'CarThumbnail',
    SUPP_PAYMENT_DOC: 'Supporting Payment Document',
    AP_DOC: "Approved Permit Document",
    OCR_DOC: "Ownership Certificate (VOC)",//"Vehicle Registration",
    SETTLEMENT_DOC: "Settlement Document",

    /** Labels for field-mapping UI (table type dropdown & previews). Keys match backend tableType strings. */
    FIELD_MAPPING_TABLE_TYPE_LABELS: {
        master: 'Master',
        detail: 'Detail',
        address: 'Address',
        bankAccount: 'Bank account',
        eInvoiceEntity: 'E-Invoice entity',
        branch: 'Branch',
        attachment: 'Attachment',
        settlement: 'Settlement',
        todo: 'Todo',
        payment: 'Payment line',
        additionalCharge: 'Additional charge',
    } as Record<string, string>,

    // MODULE TABLE TYPES - Maps module code to available tableTypes for field mapping
    // Backend maintains the actual module mappings in tableTypeModuleMap
    MODULE_TABLE_TYPES: {
        BNK: ['master', 'branch'], // Bank: master (Bank module), branch (BankBranch module)
        SUP: ['master', 'address', 'bankAccount', 'eInvoiceEntity'], // Supplier: master; address/bankAccount/eInvoiceEntity match supplier.tableTypeModuleMap + grouping tableTypeFieldMap
        /** Same shape as SUP — matches customer.tableTypeModuleMap + importTableTypeFieldMap (Address, CustomerBankAccount, EInvoiceEntity). */
        CUS: ['master', 'address', 'bankAccount', 'eInvoiceEntity'],
        ACT: ['master'], // AdditionalChargeType: master table only
        AST: ['master'], // AccessoryType: master table only
        ACC: ['master'], // Accessory: master table only
        PTY: ['master'], // PriceType: master table only
        /** Matches car-inventory tableTypeModuleMap (master + import/grouped child types). */
        CIV: ['master', 'attachment', 'todo'],
        /** Matches car-inventory-cost.tableTypeModuleMap (master + detail/payment + attachment). */
        CCT: ['master', 'detail', 'attachment'],
        /** Matches sales-order.tableTypeModuleMap (master + vehicle lines + charges + attachments). */
        SO: ['master', 'detail', 'additionalCharge', 'attachment'],
        /** Matches loan-application.tableTypeModuleMap (master + bank detail lines + attachments). */
        LNA: ['master', 'detail', 'attachment'],
        /** Matches customer-payment.tableTypeModuleMap (master + receipt/supporting attachments). */
        CPY: ['master', 'attachment'],
        PO: ['master', 'detail', 'settlement', 'attachment'],
        PRQ: ['master', 'attachment']
    },

}

/** T0031 — visible label for consignment stock (single source for UI copy) */
export const CONSIGNMENT_LABEL = 'Consignment';

export default APP_CONST;